// Loads GTM and the GA4 gtag snippet lazily to protect INP / TBT.
// Google Consent Mode defaults and Cookiebot stay eager in nuxt.config.js,
// so consent signaling is unaffected.

const GTM_ID = "GTM-KQKW3C4";
const GA4_ID = "G-FEXQ46DRSW";
const FB_PIXEL_ID = "1389738279143400";
const IDLE_FALLBACK_MS = 4000;

function injectGtm() {
  if ((window as any).__esyGtmLoaded) return;
  (window as any).__esyGtmLoaded = true;

  // Pre-seed fbq's queue so `set autoConfig false` runs before GTM's FB
  // Pixel tag calls `init`. This prevents fbevents.js from installing the
  // document-level click listener that walks the DOM on every click —
  // the dominant INP cost on segmented-control / tab interactions.
  const w = window as any;
  if (!w.fbq) {
    const fbq: any = function (...args: unknown[]) {
      fbq.callMethod ? fbq.callMethod(...args) : fbq.queue.push(args);
    };
    if (!w._fbq) w._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
    w.fbq = fbq;
  }
  w.fbq("set", "autoConfig", "false", FB_PIXEL_ID);

  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push({
    "gtm.start": Date.now(),
    event: "gtm.js",
  });

  const gtmScript = document.createElement("script");
  gtmScript.async = true;
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(gtmScript);

  const ga4Script = document.createElement("script");
  ga4Script.async = true;
  ga4Script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(ga4Script);

  function gtag(...args: unknown[]) {
    (window as any).dataLayer.push(args);
  }
  (window as any).gtag = (window as any).gtag || gtag;
  (window as any).gtag("js", new Date());
}

export default () => {
  if (typeof window === "undefined") return;

  const interactionEvents = ["pointerdown", "keydown", "scroll", "touchstart"];
  const listenerOpts: AddEventListenerOptions = {
    once: true,
    passive: true,
    capture: true,
  };

  const trigger = () => {
    cleanup();
    injectGtm();
  };

  const cleanup = () => {
    if (idleTimer) window.clearTimeout(idleTimer);
    interactionEvents.forEach((evt) =>
      window.removeEventListener(evt, trigger, listenerOpts as any),
    );
  };

  interactionEvents.forEach((evt) =>
    window.addEventListener(evt, trigger, listenerOpts),
  );

  const idleTimer = window.setTimeout(() => {
    if ((window as any).requestIdleCallback) {
      (window as any).requestIdleCallback(trigger, { timeout: 2000 });
    } else {
      trigger();
    }
  }, IDLE_FALLBACK_MS);
};
